<table>
  <thead>
    <tr>
      <th
        class="previous available"
        (click)="previousMonth()"
        [attr.disabled]="!canGoToPreviousMonth(month, minMonth)"
      >
        <i class="fa fa-chevron-left"></i>
      </th>
      <th colspan="5" class="month">{{ monthName }}</th>
      <th
        class="next available"
        (click)="nextMonth()"
        [attr.disabled]="!canGoToNextMonth(month, maxMonth)"
      >
        <i class="fa fa-chevron-right"></i>
      </th>
    </tr>
    <tr>
      <th *ngFor="let day of weekdays">{{ day }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let week of weeks">
      <td
        *ngFor="let day of week.days"
        class="available"
        [class.off]="!day.inCurrentMonth"
        [class.in-range]="isInDaterange(day.date)"
        [class.active]="
          isStartDate(day.date) || (!singleDay && isEndDate(day.date))
        "
        [class.start-date]="isStartDate(day.date) && !singleDay"
        [class.end-date]="isEndDate(day.date) && !singleDay"
        (click)="selectDate(day.date, $event)"
      >
        {{ day.day }}
      </td>
    </tr>
  </tbody>
</table>
